// ============================================================
// PRODUCT CATALOG — edit this file to add, remove, or update
// products and categories.
//
// Each product needs:
//   id          — unique string (keep as-is or any unique value)
//   name        — full product name
//   category    — must match one of the CATEGORIES list below
//   brand       — brand / manufacturer name
//   model_number
//   short_description
//   specs       — array of short spec strings
//   features    — array of feature strings
//   availability — "In Stock" | "Out of Stock" | "Pre-Order"
//   datasheet_url, image_url — optional strings
// ============================================================

export const CATEGORIES = [
  "Core Switches",
  "Managed & Unmanaged PoE Switches",
  "Enterprise Routers",
  "Firewalls",
  "Wireless Access Points",
  "Wi-Fi Controllers",
  "NVRs",
  "NAS Storage",
  "Rack Servers",
  "Server Cabinets & Network Racks",
  "UPS Systems",
  "SFP/SFP+/QSFP Modules",
  "Fiber Optic Cables & Patch Cords",
  "Patch Panels",
  "Cat6/Cat6A/Cat7 Cables",
  "Media Converters",
  "Network Accessories",
  "IP Phones",
  "CCTV Networking Equipment",
  "Data Center Networking Products",
];

export const PRODUCTS = [
  // ── Core Switches ──────────────────────────────────────────
  {
    id: "cs-001",
    name: "Cisco Nexus 9336C-FX2 Core Switch",
    category: "Core Switches",
    brand: "Cisco",
    model_number: "N9K-C9336C-FX2",
    short_description: "1U 36-port 40/100G data center core switch with ACI and NX-OS support.",
    specs: ["36 x QSFP28 100G", "7.2 Tbps switching", "NX-OS / ACI"],
    features: ["Cisco ACI ready", "VXLAN EVPN", "Telemetry streaming", "Dual PSU"],
    availability: "In Stock",
    datasheet_url: "",
    image_url: "",
  },
  {
    id: "cs-002",
    name: "Juniper QFX5120-48Y Core Switch",
    category: "Core Switches",
    brand: "Juniper Networks",
    model_number: "QFX5120-48Y-AFI",
    short_description: "48-port 25G and 8-port 100G data center core switch running Junos EVO.",
    specs: ["48 x 25G SFP28", "8 x 100G QSFP28", "Junos EVO"],
    features: ["EVPN/VXLAN", "MACsec", "Zero-touch provisioning", "Front-to-back airflow"],
    availability: "In Stock",
    datasheet_url: "",
    image_url: "",
  },
  {
    id: "cs-003",
    name: "Aruba CX 8325-48Y8C Core Switch",
    category: "Core Switches",
    brand: "HPE Aruba Networking",
    model_number: "JL624A",
    short_description: "48-port 25G high-performance core with VSX high availability and NetEdit automation.",
    specs: ["48 x 25G", "8 x 100G", "AOS-CX"],
    features: ["VSX pair", "NAE analytics", "Line-rate L2/L3", "Redundant fans"],
    availability: "In Stock",
    datasheet_url: "",
    image_url: "",
  },
  {
    id: "cs-004",
    name: "Extreme SLX 9540-48S Core Switch",
    category: "Core Switches",
    brand: "Extreme Networks",
    model_number: "SLX 9540-48S",
    short_description: "Compact 1U DC edge/core switch built for automation and telemetry.",
    specs: ["48 x 10G SFP+", "6 x 100G QSFP28", "SLX-OS"],
    features: ["Guest OS containers", "Streaming telemetry", "VXLAN routing", "1+1 PSU"],
    availability: "In Stock",
    datasheet_url: "",
    image_url: "",
  },
  {
    id: "cs-005",
    name: "Huawei CloudEngine S12700E Core Switch",
    category: "Core Switches",
    brand: "Huawei",
    model_number: "CE12700E-4",
    short_description: "Intent-driven modular core chassis for large campus and data center fabrics.",
    specs: ["Modular 4-slot", "Up to 57.6 Tbps", "VRP"],
    features: ["Intelligent fabric", "AI-based ops", "iStack", "High availability"],
    availability: "In Stock",
    datasheet_url: "",
    image_url: "",
  },

  // ── Managed & Unmanaged PoE Switches ───────────────────────
  {
    id: "poe-001",
    name: "Cisco Catalyst 9200L 48-Port PoE+ Switch",
    category: "Managed & Unmanaged PoE Switches",
    brand: "Cisco",
    model_number: "C9200L-48P-4G-E",
    short_description: "Managed L3 access switch with 48 ports of PoE+ and 4x 1G SFP uplinks.",
    specs: ["48 x GE PoE+", "4 x 1G SFP", "IOS XE"],
    features: ["StackWise-80", "740W PoE budget", "Encrypted traffic analytics", "Cisco DNA ready"],
    availability: "In Stock",
    datasheet_url: "",
    image_url: "",
  },
  {
    id: "poe-002",
    name: "Aruba 2930F 48G PoE+ Switch",
    category: "Managed & Unmanaged PoE Switches",
    brand: "HPE Aruba Networking",
    model_number: "JL262A",
    short_description: "Layer 3 managed PoE+ switch for enterprise access with dynamic segmentation.",
    specs: ["48 x GE PoE+", "4 x SFP/SFP+", "ArubaOS-Switch"],
    features: ["Dynamic segmentation", "740W PoE", "Aruba Central cloud", "Robust QoS"],
    availability: "In Stock",
    datasheet_url: "",
    image_url: "",
  },
  {
    id: "poe-003",
    name: "Ubiquiti UniFi Pro Max 48 PoE Switch",
    category: "Managed & Unmanaged PoE Switches",
    brand: "Ubiquiti",
    model_number: "USW-Pro-Max-48-PoE",
    short_description: "48-port managed 2.5G/1G PoE++ switch with 25G SFP28 uplinks for UniFi networks.",
    specs: ["48 x 2.5GbE/GbE PoE++", "4 x 25G SFP28", "720W PoE"],
    features: ["UniFi Network integration", "L3 features", "Hot-swap PSU", "Console USB-C"],
    availability: "In Stock",
    datasheet_url: "",
    image_url: "",
  },
  {
    id: "poe-004",
    name: "TP-Link JetStream 24-Port Gigabit PoE+ Switch",
    category: "Managed & Unmanaged PoE Switches",
    brand: "TP-Link",
    model_number: "TL-SG3428MP",
    short_description: "L2+ managed PoE+ switch with 384W budget and 4x SFP uplinks.",
    specs: ["24 x GE PoE+", "4 x SFP", "384W"],
    features: ["Omada SDN", "L2+ static routing", "Voice VLAN", "Rack-mount 1U"],
    availability: "In Stock",
    datasheet_url: "",
    image_url: "",
  },
  {
    id: "poe-005",
    name: "Netgear ProSAFE 8-Port Gigabit PoE+ Unmanaged Switch",
    category: "Managed & Unmanaged PoE Switches",
    brand: "Netgear",
    model_number: "GS308PP",
    short_description: "Plug-and-play unmanaged desktop switch with 8 PoE+ ports and 83W budget.",
    specs: ["8 x GE PoE+", "83W PoE", "Silent fanless"],
    features: ["Metal casing", "Auto MDI/MDIX", "Traffic prioritization", "Wall/desk mount"],
    availability: "In Stock",
    datasheet_url: "",
    image_url: "",
  },

  // ── Enterprise Routers ──────────────────────────────────────
  {
    id: "rt-001",
    name: "Cisco ISR 4451-X Integrated Services Router",
    category: "Enterprise Routers",
    brand: "Cisco",
    model_number: "ISR4451-X/K9",
    short_description: "Branch aggregation router delivering up to 2 Gbps with modular NIM slots.",
    specs: ["Up to 2 Gbps", "4 x GE WAN", "3 x NIM slots"],
    features: ["SD-WAN ready", "IOS XE", "Cisco Umbrella integration", "Hardware crypto"],
    availability: "In Stock",
    datasheet_url: "",
    image_url: "",
  },
  {
    id: "rt-002",
    name: "Juniper MX204 Universal Routing Platform",
    category: "Enterprise Routers",
    brand: "Juniper Networks",
    model_number: "MX204-HWBASE-AC-FS",
    short_description: "Compact 1U universal routing platform up to 400 Gbps for edge and metro.",
    specs: ["4 x 100GbE", "8 x 10GbE", "Junos"],
    features: ["Advanced segment routing", "MPLS", "Time-based licensing", "AI Ops"],
    availability: "In Stock",
    datasheet_url: "",
    image_url: "",
  },
  {
    id: "rt-003",
    name: "MikroTik CCR2116-12G-4S+ Cloud Core Router",
    category: "Enterprise Routers",
    brand: "MikroTik",
    model_number: "CCR2116-12G-4S+",
    short_description: "16-core ARM router with 13 x GbE and 4 x 10G SFP+ ports.",
    specs: ["13 x GbE", "4 x 10G SFP+", "RouterOS v7"],
    features: ["Dual redundant PSU", "Hot-swap PSU", "40 Gbps throughput", "L4 firewall"],
    availability: "In Stock",
    datasheet_url: "",
    image_url: "",
  },
  {
    id: "rt-004",
    name: "Aruba 9004 Branch Gateway",
    category: "Enterprise Routers",
    brand: "HPE Aruba Networking",
    model_number: "R1B24A",
    short_description: "Cloud-managed SD-WAN branch gateway with integrated security.",
    specs: ["4 x GE WAN/LAN", "1.5 Gbps", "ArubaOS 10"],
    features: ["EdgeConnect SD-WAN", "IDS/IPS", "Aruba Central", "PoE-in support"],
    availability: "In Stock",
    datasheet_url: "",
    image_url: "",
  },
  {
    id: "rt-005",
    name: "Huawei NetEngine AR6300 Enterprise Router",
    category: "Enterprise Routers",
    brand: "Huawei",
    model_number: "AR6300",
    short_description: "High-performance AI-powered enterprise router with SD-WAN capabilities.",
    specs: ["Up to 40 Gbps", "8 x SIC slots", "VRP"],
    features: ["SRv6 support", "iMaster NCE", "AI-based path selection", "Dual PSU"],
    availability: "In Stock",
    datasheet_url: "",
    image_url: "",
  },

  // ── Firewalls ───────────────────────────────────────────────
  {
    id: "fw-001",
    name: "Fortinet FortiGate 100F NGFW",
    category: "Firewalls",
    brand: "Fortinet",
    model_number: "FG-100F",
    short_description: "Next-gen firewall for mid-market with SD-WAN, IPS and ZTNA.",
    specs: ["20 Gbps FW", "7 Gbps IPS", "22 x GE"],
    features: ["Security Fabric", "Native SD-WAN", "SSL inspection", "ZTNA agent"],
    availability: "In Stock",
    datasheet_url: "",
    image_url: "",
  },
  {
    id: "fw-002",
    name: "Fortinet FortiGate 200F NGFW",
    category: "Firewalls",
    brand: "Fortinet",
    model_number: "FG-200F",
    short_description: "Enterprise NGFW with 27 Gbps throughput and integrated SD-WAN.",
    specs: ["27 Gbps FW", "8.4 Gbps IPS", "18 x GE"],
    features: ["SoC4 acceleration", "SD-WAN", "TLS 1.3 inspection", "FortiGuard AI"],
    availability: "In Stock",
    datasheet_url: "",
    image_url: "",
  },
  {
    id: "fw-003",
    name: "Cisco Firepower 2110 NGFW",
    category: "Firewalls",
    brand: "Cisco",
    model_number: "FPR2110-NGFW-K9",
    short_description: "Threat-focused NGFW with FTD and integrated advanced malware protection.",
    specs: ["1.9 Gbps FW", "12 x GE", "FTD 7.x"],
    features: ["Snort 3 IPS", "AMP", "URL filtering", "Cisco Talos threat intel"],
    availability: "In Stock",
    datasheet_url: "",
    image_url: "",
  },
  {
    id: "fw-004",
    name: "Juniper SRX340 Services Gateway",
    category: "Firewalls",
    brand: "Juniper Networks",
    model_number: "SRX340-SYS-JB",
    short_description: "Branch-office firewall with 3 Gbps FW throughput and modular slots.",
    specs: ["3 Gbps FW", "16 x GE", "Junos"],
    features: ["UTM", "SSL VPN", "Sky ATP", "16 MIC slots"],
    availability: "In Stock",
    datasheet_url: "",
    image_url: "",
  },
  {
    id: "fw-005",
    name: "Huawei USG6635E AI Firewall",
    category: "Firewalls",
    brand: "Huawei",
    model_number: "USG6635E-AC",
    short_description: "AI-powered NGFW with 33 Gbps IPS throughput and comprehensive threat protection.",
    specs: ["50 Gbps FW", "33 Gbps IPS", "22 x GE"],
    features: ["AI-based sandbox", "CGI-based mgmt", "Cloud CIS", "IPv6 dual-stack"],
    availability: "In Stock",
    datasheet_url: "",
    image_url: "",
  },

  // ── Wireless Access Points ──────────────────────────────────
  {
    id: "ap-001",
    name: "Cisco Catalyst 9130AXI Wi-Fi 6 Access Point",
    category: "Wireless Access Points",
    brand: "Cisco",
    model_number: "C9130AXI-A",
    short_description: "Enterprise-grade Wi-Fi 6 AP with 8x8 MU-MIMO and CleanAir spectrum intelligence.",
    specs: ["Wi-Fi 6 8x8", "5.38 Gbps", "mGig 2.5G uplink"],
    features: ["Software-defined radios", "CleanAir Pro", "IoT ready", "Cisco DNA"],
    availability: "In Stock",
    datasheet_url: "",
    image_url: "",
  },
  {
    id: "ap-002",
    name: "Aruba AP-635 Wi-Fi 6E Access Point",
    category: "Wireless Access Points",
    brand: "HPE Aruba Networking",
    model_number: "AP-635",
    short_description: "Tri-band Wi-Fi 6E access point delivering 7.8 Gbps aggregate throughput.",
    specs: ["Wi-Fi 6E tri-band", "7.8 Gbps", "2.5GbE uplink"],
    features: ["AI-powered RF", "OFDMA + BSS Coloring", "Bluetooth 5.2", "Zigbee radio"],
    availability: "In Stock",
    datasheet_url: "",
    image_url: "",
  },
  {
    id: "ap-003",
    name: "Ubiquiti UniFi 6 Enterprise Access Point",
    category: "Wireless Access Points",
    brand: "Ubiquiti",
    model_number: "U6-Enterprise",
    short_description: "Ceiling-mount Wi-Fi 6E AP designed for high-density enterprise deployments.",
    specs: ["Wi-Fi 6E tri-band", "10.2 Gbps", "2.5GbE PoE++"],
    features: ["600+ clients", "Beam-forming", "UniFi Network", "Enclosed antennas"],
    availability: "In Stock",
    datasheet_url: "",
    image_url: "",
  },
  {
    id: "ap-004",
    name: "Ruckus R750 Wi-Fi 6 Access Point",
    category: "Wireless Access Points",
    brand: "Ruckus Networks",
    model_number: "901-R750-WW00",
    short_description: "Wi-Fi 6 access point with BeamFlex+ adaptive antenna technology.",
    specs: ["Wi-Fi 6 4x4:4", "3.55 Gbps", "2.5GbE uplink"],
    features: ["BeamFlex+", "OFDMA + MU-MIMO", "IoT (BLE/Zigbee)", "SmartMesh"],
    availability: "In Stock",
    datasheet_url: "",
    image_url: "",
  },
  {
    id: "ap-005",
    name: "TP-Link Omada EAP670 Wi-Fi 6 Access Point",
    category: "Wireless Access Points",
    brand: "TP-Link",
    model_number: "EAP670",
    short_description: "AX5400 ceiling AP with 2.5G uplink and centralized Omada SDN management.",
    specs: ["Wi-Fi 6 AX5400", "2.5GbE PoE+", "Ceiling mount"],
    features: ["Omada SDN", "Seamless roaming", "Band steering", "Fanless"],
    availability: "In Stock",
    datasheet_url: "",
    image_url: "",
  },

  // ── Wi-Fi Controllers ───────────────────────────────────────
  {
    id: "wc-001",
    name: "Cisco Catalyst 9800-40 Wireless Controller",
    category: "Wi-Fi Controllers",
    brand: "Cisco",
    model_number: "C9800-40-K9",
    short_description: "1U wireless controller supporting up to 2000 APs and 32000 clients.",
    specs: ["Up to 2000 APs", "32K clients", "40 Gbps"],
    features: ["Cisco IOS XE", "High availability", "Cisco DNA Center", "Encrypted traffic analytics"],
    availability: "In Stock",
    datasheet_url: "",
    image_url: "",
  },
  {
    id: "wc-002",
    name: "Aruba 7220 Mobility Controller",
    category: "Wi-Fi Controllers",
    brand: "HPE Aruba Networking",
    model_number: "JW641A",
    short_description: "Enterprise mobility controller supporting up to 2048 APs with rich services.",
    specs: ["Up to 2048 APs", "32K clients", "40 Gbps"],
    features: ["ArubaOS 8", "AirMatch", "ClearPass ready", "Advanced RF mgmt"],
    availability: "In Stock",
    datasheet_url: "",
    image_url: "",
  },
  {
    id: "wc-003",
    name: "Ruckus SmartZone 300 Controller",
    category: "Wi-Fi Controllers",
    brand: "Ruckus Networks",
    model_number: "SZ-300",
    short_description: "Carrier-grade SmartZone controller for large-scale enterprise Wi-Fi.",
    specs: ["Up to 10K APs", "150K clients", "80 Gbps"],
    features: ["SmartCell insight", "ClusterRedundancy", "Multi-tenant", "Open APIs"],
    availability: "In Stock",
    datasheet_url: "",
    image_url: "",
  },
  {
    id: "wc-004",
    name: "Huawei AC6805 Access Controller",
    category: "Wi-Fi Controllers",
    brand: "Huawei",
    model_number: "AC6805",
    short_description: "Enterprise WLAN controller with AI-powered radio calibration.",
    specs: ["Up to 6144 APs", "64K users", "40 Gbps"],
    features: ["Big data analytics", "Roaming across L3", "iMaster NCE-Campus", "Redundant PSU"],
    availability: "In Stock",
    datasheet_url: "",
    image_url: "",
  },
  {
    id: "wc-005",
    name: "Ubiquiti UniFi Cloud Key Gen2 Plus",
    category: "Wi-Fi Controllers",
    brand: "Ubiquiti",
    model_number: "UCK-G2-PLUS",
    short_description: "Hybrid cloud key controller with local UniFi Network + UniFi Protect application.",
    specs: ["1TB HDD", "UniFi Network + Protect", "PoE powered"],
    features: ["Zero-config onboarding", "Encrypted at rest", "Battery backup", "Console color LCD"],
    availability: "In Stock",
    datasheet_url: "",
    image_url: "",
  },

  // ── NVRs ────────────────────────────────────────────────────
  {
    id: "nvr-001",
    name: "Synology DVA3221 Deep Learning NVR",
    category: "NVRs",
    brand: "Synology",
    model_number: "DVA3221",
    short_description: "8-bay AI NVR appliance with GPU-accelerated video analytics.",
    specs: ["8 bays", "Intel Xeon", "NVIDIA GPU"],
    features: ["People/vehicle detection", "Intrusion analytics", "H.265 support", "Surveillance Station"],
    availability: "In Stock",
    datasheet_url: "",
    image_url: "",
  },
  {
    id: "nvr-002",
    name: "QNAP QVR Pro 4K NVR Appliance",
    category: "NVRs",
    brand: "QNAP",
    model_number: "QVP-85B",
    short_description: "Dedicated 8-bay NVR pre-loaded with QVR Pro and 8 free channels.",
    specs: ["8 bays", "Intel Core i5", "8 IP channels included"],
    features: ["QVR Pro", "AI-based smart search", "HDMI local monitor", "PoE ready via switch"],
    availability: "In Stock",
    datasheet_url: "",
    image_url: "",
  },
  {
    id: "nvr-003",
    name: "Ubiquiti UniFi Protect NVR Pro",
    category: "NVRs",
    brand: "Ubiquiti",
    model_number: "UNVR-PRO",
    short_description: "7-bay high-density NVR for the UniFi Protect ecosystem with 15 Gbps throughput.",
    specs: ["7 x 3.5\" bays", "RAID 1/5/10", "PoE + AC"],
    features: ["Zero-config UniFi Protect", "OLED display", "Redundant PSU option", "Redundant fans"],
    availability: "In Stock",
    datasheet_url: "",
    image_url: "",
  },
  {
    id: "nvr-004",
    name: "TP-Link VIGI 16-Channel NVR",
    category: "NVRs",
    brand: "TP-Link",
    model_number: "VIGI NVR2016H",
    short_description: "16-channel 4K H.265+ NVR with 2 SATA bays and free VIGI Security Manager.",
    specs: ["16 channels", "80 Mbps ingress", "2 SATA bays"],
    features: ["Plug & play VIGI", "Face recognition", "Motion analytics", "HDMI + VGA"],
    availability: "In Stock",
    datasheet_url: "",
    image_url: "",
  },
  {
    id: "nvr-005",
    name: "D-Link 16-Channel PoE Network Video Recorder",
    category: "NVRs",
    brand: "D-Link",
    model_number: "DNR-4020-16P",
    short_description: "Standalone 16-channel PoE NVR with dual SATA and camera auto-discovery.",
    specs: ["16 channels", "160 Mbps", "2 SATA bays"],
    features: ["ONVIF Profile G/S/T", "PoE budget 200W", "Dual streams", "Mobile app"],
    availability: "In Stock",
    datasheet_url: "",
    image_url: "",
  },

  // ── NAS Storage ─────────────────────────────────────────────
  {
    id: "nas-001",
    name: "Synology RackStation RS3621xs+",
    category: "NAS Storage",
    brand: "Synology",
    model_number: "RS3621xs+",
    short_description: "12-bay 2U enterprise NAS with Xeon D-1541 and ECC memory.",
    specs: ["12 bays", "Xeon D-1541", "8GB ECC RAM"],
    features: ["Btrfs + snapshots", "10GbE ready", "Active Backup Suite", "Docker support"],
    availability: "In Stock",
    datasheet_url: "",
    image_url: "",
  },
  {
    id: "nas-002",
    name: "QNAP TS-h1290FX All-NVMe ZFS NAS",
    category: "NAS Storage",
    brand: "QNAP",
    model_number: "TS-h1290FX",
    short_description: "12-bay all-NVMe ZFS NAS powered by AMD EPYC for enterprise workloads.",
    specs: ["12 x U.2 NVMe", "AMD EPYC 7302P", "QuTS hero (ZFS)"],
    features: ["ZFS with dedupe", "25GbE add-on", "SnapSync", "VMware Ready"],
    availability: "In Stock",
    datasheet_url: "",
    image_url: "",
  },
  {
    id: "nas-003",
    name: "Synology DiskStation DS1823xs+",
    category: "NAS Storage",
    brand: "Synology",
    model_number: "DS1823xs+",
    short_description: "8-bay high-performance desktop NAS with 10GbE and NVMe SSD cache slots.",
    specs: ["8 bays", "AMD Ryzen V1780B", "10GbE + 1GbE"],
    features: ["Btrfs", "NVMe cache", "SHR2 support", "MailPlus / Drive"],
    availability: "In Stock",
    datasheet_url: "",
    image_url: "",
  },
  {
    id: "nas-004",
    name: "QNAP 16-Bay ZFS Rackmount NAS",
    category: "NAS Storage",
    brand: "QNAP",
    model_number: "TS-1655",
    short_description: "16-bay hybrid ZFS NAS combining 8x3.5\" SATA + 8x2.5\" SATA.",
    specs: ["16 bays hybrid", "Intel Atom C5125", "2 x 2.5GbE"],
    features: ["QuTS hero", "SSD tiering", "Snapshot replica", "Rack-mount 3U"],
    availability: "In Stock",
    datasheet_url: "",
    image_url: "",
  },
  {
    id: "nas-005",
    name: "Quantum DXi9000 Backup Appliance",
    category: "NAS Storage",
    brand: "Quantum",
    model_number: "DXi9000",
    short_description: "Enterprise deduplication backup appliance with up to 1PB usable capacity.",
    specs: ["Up to 1 PB usable", "Inline dedupe", "10/25GbE"],
    features: ["DXi Advanced Reporting", "Veeam ready", "Cloud tier", "Immutable snapshots"],
    availability: "In Stock",
    datasheet_url: "",
    image_url: "",
  },

  // ── Rack Servers ────────────────────────────────────────────
  {
    id: "srv-001",
    name: "Dell PowerEdge R750 Rack Server",
    category: "Rack Servers",
    brand: "Dell Technologies",
    model_number: "PowerEdge R750",
    short_description: "2U dual-socket rack server for demanding enterprise workloads.",
    specs: ["2 x Xeon Scalable Gen 3", "Up to 8TB DDR4", "24 x NVMe"],
    features: ["iDRAC 9", "PowerEdge RAID Controller 11", "OpenManage", "TPM 2.0"],
    availability: "In Stock",
    datasheet_url: "",
    image_url: "",
  },
  {
    id: "srv-002",
    name: "HPE ProLiant DL380 Gen11 Server",
    category: "Rack Servers",
    brand: "HPE",
    model_number: "P52560-B21",
    short_description: "Flagship 2U enterprise server with intelligent automation and security.",
    specs: ["2 x Xeon Scalable", "Up to 8TB DDR5", "iLO 6"],
    features: ["Silicon Root of Trust", "OneView", "OCP 3.0", "GreenLake ready"],
    availability: "In Stock",
    datasheet_url: "",
    image_url: "",
  },
  {
    id: "srv-003",
    name: "Lenovo ThinkSystem SR650 V3",
    category: "Rack Servers",
    brand: "Lenovo",
    model_number: "SR650V3",
    short_description: "Versatile 2U rack server optimized for cloud and virtualization.",
    specs: ["2 x 4th Gen Xeon", "DDR5 ECC", "40 x NVMe"],
    features: ["XClarity Controller", "TruDDR5", "Neptune liquid cooling ready", "GPU-capable"],
    availability: "In Stock",
    datasheet_url: "",
    image_url: "",
  },
  {
    id: "srv-004",
    name: "Dell PowerEdge R660 Rack Server",
    category: "Rack Servers",
    brand: "Dell Technologies",
    model_number: "PowerEdge R660",
    short_description: "1U dual-socket high-density server with 4th Gen Xeon and DDR5.",
    specs: ["2 x 4th Gen Xeon", "DDR5 4800", "10 x NVMe"],
    features: ["iDRAC 9 15G", "SmartFabric Storage", "PERC12", "Redundant PSU"],
    availability: "In Stock",
    datasheet_url: "",
    image_url: "",
  },
  {
    id: "srv-005",
    name: "HPE ProLiant DL360 Gen11 Server",
    category: "Rack Servers",
    brand: "HPE",
    model_number: "P52499-B21",
    short_description: "1U high-performance server for space-constrained data center racks.",
    specs: ["2 x Xeon Scalable", "DDR5", "8 x NVMe"],
    features: ["iLO 6", "OneView", "PCIe Gen5", "Redundant hot-plug fans"],
    availability: "In Stock",
    datasheet_url: "",
    image_url: "",
  },

  // ── Server Cabinets & Network Racks ─────────────────────────
  {
    id: "rack-001",
    name: "APC NetShelter SX 42U Enclosure",
    category: "Server Cabinets & Network Racks",
    brand: "APC by Schneider Electric",
    model_number: "AR3100",
    short_description: "42U 600mm wide 1070mm deep enclosure with vented doors.",
    specs: ["42U", "600 x 1070mm", "1364 kg static"],
    features: ["Perforated doors", "Cable manager rings", "Split rear door", "TAA compliant"],
    availability: "In Stock",
    datasheet_url: "",
    image_url: "",
  },
  {
    id: "rack-002",
    name: "Vertiv VR3350 42U Server Rack",
    category: "Server Cabinets & Network Racks",
    brand: "Vertiv",
    model_number: "VR3350",
    short_description: "42U server rack with universal 4-post design and adjustable rails.",
    specs: ["42U", "800 x 1100mm", "1360 kg static"],
    features: ["Toolless rail adjust", "Vented front/rear", "Cable pass-through", "Ships assembled"],
    availability: "In Stock",
    datasheet_url: "",
    image_url: "",
  },
  {
    id: "rack-003",
    name: "Panduit Net-Access N-Type Cabinet 42U",
    category: "Server Cabinets & Network Racks",
    brand: "Panduit",
    model_number: "N8212B",
    short_description: "42U high-airflow cabinet designed for high-density switch deployments.",
    specs: ["42U", "800 x 1200mm", "1361 kg static"],
    features: ["Split doors", "Baying kit ready", "Grounding kit", "Cable finger accessory"],
    availability: "In Stock",
    datasheet_url: "",
    image_url: "",
  },
  {
    id: "rack-004",
    name: "APC NetShelter SX 24U Wall-Mount Cabinet",
    category: "Server Cabinets & Network Racks",
    brand: "APC by Schneider Electric",
    model_number: "AR3104",
    short_description: "Compact 24U enclosure for branch offices and telecom rooms.",
    specs: ["24U", "600 x 1070mm", "907 kg static"],
    features: ["Removable side panels", "Tempered glass door", "Vertical cable managers", "Casters included"],
    availability: "In Stock",
    datasheet_url: "",
    image_url: "",
  },
  {
    id: "rack-005",
    name: "Vertiv VR3300 27U Wall-Mount Rack",
    category: "Server Cabinets & Network Racks",
    brand: "Vertiv",
    model_number: "VR3300",
    short_description: "27U wall-mount rack with lockable side and front doors.",
    specs: ["27U", "600 x 600mm", "300 kg static"],
    features: ["Two-piece wall bracket", "Vented mesh", "1U cable managers", "Ships assembled"],
    availability: "In Stock",
    datasheet_url: "",
    image_url: "",
  },

  // ── UPS Systems ─────────────────────────────────────────────
  {
    id: "ups-001",
    name: "APC Smart-UPS SRT 10kVA Online UPS",
    category: "UPS Systems",
    brand: "APC by Schneider Electric",
    model_number: "SRT10KXLI",
    short_description: "Online double-conversion UPS for mission-critical data center loads.",
    specs: ["10 kVA / 10 kW", "Online DC", "Rack/tower"],
    features: ["SmartConnect cloud", "Pure sine wave", "Green mode", "Extended runtime options"],
    availability: "In Stock",
    datasheet_url: "",
    image_url: "",
  },
  {
    id: "ups-002",
    name: "Vertiv Liebert GXT5 6kVA Online UPS",
    category: "UPS Systems",
    brand: "Vertiv",
    model_number: "GXT5-6000IRT5UXL",
    short_description: "Rack/tower on-line UPS with output PF 1.0 and Li-ion option.",
    specs: ["6 kVA / 6 kW", "Online DC", "5U rack/tower"],
    features: ["Output PF 1.0", "LCD graphics display", "Emergency Power Off", "SNMP card slot"],
    availability: "In Stock",
    datasheet_url: "",
    image_url: "",
  },
  {
    id: "ups-003",
    name: "APC Easy UPS SMV 3kVA Line-Interactive UPS",
    category: "UPS Systems",
    brand: "APC by Schneider Electric",
    model_number: "SMV3000AI-IN",
    short_description: "3 kVA line-interactive UPS delivering reliable protection for SMB workloads.",
    specs: ["3 kVA / 2.7 kW", "Line-interactive", "AVR"],
    features: ["Pure sine wave output", "Automatic self-test", "Cold-start capable", "USB monitoring"],
    availability: "In Stock",
    datasheet_url: "",
    image_url: "",
  },
  {
    id: "ups-004",
    name: "Vertiv Liebert PSA5 1500VA UPS",
    category: "UPS Systems",
    brand: "Vertiv",
    model_number: "PSA5-1500MT120",
    short_description: "Line-interactive UPS for small networks and workstations.",
    specs: ["1.5 kVA / 900 W", "Line-interactive", "LCD display"],
    features: ["Boost & buck AVR", "USB & serial", "Battery hot-swap", "Tower form-factor"],
    availability: "In Stock",
    datasheet_url: "",
    image_url: "",
  },
  {
    id: "ups-005",
    name: "APC Symmetra LX 8kVA Modular UPS",
    category: "UPS Systems",
    brand: "APC by Schneider Electric",
    model_number: "SYA8K8I",
    short_description: "Rack-mount scalable & redundant modular UPS platform.",
    specs: ["8 kVA / 5.6 kW", "N+1 redundancy", "Scalable"],
    features: ["Hot-swap battery/power modules", "Bypass switch", "PowerChute", "Extended runtime"],
    availability: "In Stock",
    datasheet_url: "",
    image_url: "",
  },

  // ── SFP/SFP+/QSFP Modules ──────────────────────────────────
  {
    id: "sfp-001",
    name: "Cisco 10GBASE-SR SFP+ Module",
    category: "SFP/SFP+/QSFP Modules",
    brand: "Cisco",
    model_number: "SFP-10G-SR",
    short_description: "10G multi-mode SFP+ transceiver, LC connector, 300m reach.",
    specs: ["10 Gbps", "MMF 850nm", "300m OM3"],
    features: ["Digital diagnostics", "Hot-pluggable", "Cisco compatible", "LC duplex"],
    availability: "In Stock",
    datasheet_url: "",
    image_url: "",
  },
  {
    id: "sfp-002",
    name: "Juniper 100GBASE-SR4 QSFP28 Module",
    category: "SFP/SFP+/QSFP Modules",
    brand: "Juniper Networks",
    model_number: "QSFP-100G-SR4-T2",
    short_description: "100G short-reach QSFP28 optic with MPO connector for data centers.",
    specs: ["100 Gbps", "MMF 850nm", "70m OM3 / 100m OM4"],
    features: ["4x25G lanes", "MPO-12", "DDM", "Hot-pluggable"],
    availability: "In Stock",
    datasheet_url: "",
    image_url: "",
  },
  {
    id: "sfp-003",
    name: "HPE X130 10G SFP+ LC LR Transceiver",
    category: "SFP/SFP+/QSFP Modules",
    brand: "HPE",
    model_number: "JD094B",
    short_description: "10 Gigabit SFP+ single-mode transceiver up to 10km.",
    specs: ["10 Gbps", "SMF 1310nm", "10km"],
    features: ["LC duplex", "Class 1 laser", "DDM support", "HPE compatible"],
    availability: "In Stock",
    datasheet_url: "",
    image_url: "",
  },
  {
    id: "sfp-004",
    name: "TP-Link 10GBASE-LR SFP+ Module",
    category: "SFP/SFP+/QSFP Modules",
    brand: "TP-Link",
    model_number: "TL-SM5110-LR",
    short_description: "10G single-mode SFP+ for long-distance uplinks up to 10km.",
    specs: ["10 Gbps", "SMF 1310nm", "10km"],
    features: ["LC connector", "DDM/DOM", "Hot-pluggable", "TP-Link Omada compatible"],
    availability: "In Stock",
    datasheet_url: "",
    image_url: "",
  },
  {
    id: "sfp-005",
    name: "MikroTik QSFP+ 40G Optical Module",
    category: "SFP/SFP+/QSFP Modules",
    brand: "MikroTik",
    model_number: "Q+85MP01D",
    short_description: "40G QSFP+ multi-mode module with MPO connector, 100m reach on OM3.",
    specs: ["40 Gbps", "MMF 850nm", "100m OM3"],
    features: ["MPO-12", "DDMI", "Cisco/MikroTik compatible", "Hot-pluggable"],
    availability: "In Stock",
    datasheet_url: "",
    image_url: "",
  },

  // ── Fiber Optic Cables & Patch Cords ────────────────────────
  {
    id: "fib-001",
    name: "CommScope LC-LC OS2 Single-Mode Patch Cord",
    category: "Fiber Optic Cables & Patch Cords",
    brand: "CommScope",
    model_number: "TeraSPEED FEWLC-LC",
    short_description: "Duplex OS2 single-mode LC-LC patch cord with LSZH jacket.",
    specs: ["OS2 9/125μm", "LC-LC duplex", "LSZH 3.0mm"],
    features: ["Available 1-30m", "Bend insensitive", "TIA-568.3-D", "Factory tested"],
    availability: "In Stock",
    datasheet_url: "",
    image_url: "",
  },
  {
    id: "fib-002",
    name: "Corning ClearCurve OM4 LC-LC Patch Cord",
    category: "Fiber Optic Cables & Patch Cords",
    brand: "Corning",
    model_number: "CCH-01U-04-P00RE",
    short_description: "Duplex OM4 laser-optimized multi-mode LC-LC patch cord.",
    specs: ["OM4 50/125μm", "LC-LC duplex", "LSZH"],
    features: ["Bend-insensitive", "Type A polarity", "IL ≤ 0.20 dB", "1-30m lengths"],
    availability: "In Stock",
    datasheet_url: "",
    image_url: "",
  },
  {
    id: "fib-003",
    name: "Belden BB-JBC1S002 OS2 Duplex Fiber Cable",
    category: "Fiber Optic Cables & Patch Cords",
    brand: "Belden",
    model_number: "BB-JBC1S002",
    short_description: "Duplex OS2 single-mode LC-LC assembly for enterprise backbone.",
    specs: ["OS2", "LC-LC duplex", "LSZH"],
    features: ["Factory tested", "Bend insensitive", "TIA/EIA-568-D", "OFNR-rated available"],
    availability: "In Stock",
    datasheet_url: "",
    image_url: "",
  },
  {
    id: "fib-004",
    name: "Panduit LC-LC OM4 Fiber Patch Cord",
    category: "Fiber Optic Cables & Patch Cords",
    brand: "Panduit",
    model_number: "NKFPX6ELLLSM003",
    short_description: "10G-ready OM4 LC-LC duplex patch cord in aqua LSZH jacket.",
    specs: ["OM4 50/125μm", "LC-LC duplex", "3m default"],
    features: ["Type A polarity", "Enhanced insertion loss", "Aqua LSZH", "Halogen-free"],
    availability: "In Stock",
    datasheet_url: "",
    image_url: "",
  },
  {
    id: "fib-005",
    name: "Molex Duplex LC-LC OS2 Fiber Cable",
    category: "Fiber Optic Cables & Patch Cords",
    brand: "Molex",
    model_number: "F1-DFPCAAB01-2",
    short_description: "Duplex OS2 LC-LC patch cord for enterprise & data-center use.",
    specs: ["OS2 9/125μm", "LC-LC duplex", "2m default"],
    features: ["LSZH jacket", "Bend-optimized", "IL 0.3 dB max", "Molex tested"],
    availability: "In Stock",
    datasheet_url: "",
    image_url: "",
  },

  // ── Patch Panels ────────────────────────────────────────────
  {
    id: "pp-001",
    name: "Panduit 24-Port Cat6 Modular Patch Panel",
    category: "Patch Panels",
    brand: "Panduit",
    model_number: "DP245E88TGY",
    short_description: "1U 24-port loaded flat patch panel with UTP Mini-Com modules.",
    specs: ["24 ports", "Cat6", "1U"],
    features: ["Tool-less snap-in modules", "Rear cable manager", "Grounding lug", "TIA-568-C"],
    availability: "In Stock",
    datasheet_url: "",
    image_url: "",
  },
  {
    id: "pp-002",
    name: "CommScope Uniprise 24-Port Cat6 Patch Panel",
    category: "Patch Panels",
    brand: "CommScope",
    model_number: "UNP24-6L",
    short_description: "24-port loaded 1U flat patch panel with UTP jacks and LSZH-ready design.",
    specs: ["24 ports", "Cat6", "1U"],
    features: ["Universal wiring T568A/B", "Icons for labeling", "Rear cable mgmt", "UL listed"],
    availability: "In Stock",
    datasheet_url: "",
    image_url: "",
  },
  {
    id: "pp-003",
    name: "Belden 24-Port Cat6A UTP Patch Panel",
    category: "Patch Panels",
    brand: "Belden",
    model_number: "AX103254",
    short_description: "REVConnect 1U 24-port Cat6A patch panel with tool-less termination.",
    specs: ["24 ports", "Cat6A", "1U"],
    features: ["REVConnect single core", "Ergonomic termination", "Angle available", "10GBASE-T certified"],
    availability: "In Stock",
    datasheet_url: "",
    image_url: "",
  },
  {
    id: "pp-004",
    name: "Corning 1U Fiber Housing Panel",
    category: "Patch Panels",
    brand: "Corning",
    model_number: "CCH-01U",
    short_description: "1U closet connector housing for up to 3 CCH panels or modules.",
    specs: ["1U", "Holds 3 CCH panels", "72 fiber max"],
    features: ["Sliding tray", "Cable strain relief", "Universal fiber", "Lockable"],
    availability: "In Stock",
    datasheet_url: "",
    image_url: "",
  },
  {
    id: "pp-005",
    name: "Molex 24-Port Cat6 Modular Patch Panel",
    category: "Patch Panels",
    brand: "Molex",
    model_number: "KPPHD-U024-CS",
    short_description: "High-density 1U 24-port Cat6 patch panel with color coding.",
    specs: ["24 ports", "Cat6", "1U"],
    features: ["T568A/B wiring", "Colour-coded", "Rear cable strain-relief", "Cable manager included"],
    availability: "In Stock",
    datasheet_url: "",
    image_url: "",
  },

  // ── Cat6/Cat6A/Cat7 Cables ──────────────────────────────────
  {
    id: "cat-001",
    name: "CommScope Uniprise Cat6 UTP Cable 305m",
    category: "Cat6/Cat6A/Cat7 Cables",
    brand: "CommScope",
    model_number: "UNP6-4/24-BL-1000",
    short_description: "Cat6 U/UTP 4-pair cable rated for 1000BASE-T, 305m pull box.",
    specs: ["Cat6 U/UTP", "550 MHz", "305m box"],
    features: ["LSZH available", "TIA-568.2-D", "Sweeptested", "CMR/CMP options"],
    availability: "In Stock",
    datasheet_url: "",
    image_url: "",
  },
  {
    id: "cat-002",
    name: "Belden Cat6A U/FTP 10GXS12 Cable 305m",
    category: "Cat6/Cat6A/Cat7 Cables",
    brand: "Belden",
    model_number: "10GXS12",
    short_description: "Cat6A U/FTP shielded cable rated for 10GBASE-T up to 100m.",
    specs: ["Cat6A U/FTP", "500 MHz", "305m box"],
    features: ["Bonded pairs", "PoE++ certified", "MediaTuff jacket", "TAA compliant"],
    availability: "In Stock",
    datasheet_url: "",
    image_url: "",
  },
  {
    id: "cat-003",
    name: "Panduit TX6A Cat6A U/UTP Cable 305m",
    category: "Cat6/Cat6A/Cat7 Cables",
    brand: "Panduit",
    model_number: "PUL6AWH-UY",
    short_description: "Cat6A U/UTP 4-pair 23AWG cable optimized for structured cabling.",
    specs: ["Cat6A", "500 MHz", "305m box"],
    features: ["10GBASE-T", "Warranty-eligible", "LSZH option", "TAA compliant"],
    availability: "In Stock",
    datasheet_url: "",
    image_url: "",
  },
  {
    id: "cat-004",
    name: "Corning Cat6A U/FTP Enterprise Cable 305m",
    category: "Cat6/Cat6A/Cat7 Cables",
    brand: "Corning",
    model_number: "CG6A-U/FTP-500",
    short_description: "Corning Solutions Cat6A U/FTP LSZH bulk cable for enterprise structured cabling.",
    specs: ["Cat6A U/FTP", "500 MHz", "305m reel"],
    features: ["Sweeptested to 500 MHz", "Halogen free", "PoE++ ready", "Warranty coverage"],
    availability: "In Stock",
    datasheet_url: "",
    image_url: "",
  },
  {
    id: "cat-005",
    name: "Molex PowerCat 6A U/UTP Cable 305m",
    category: "Cat6/Cat6A/Cat7 Cables",
    brand: "Molex",
    model_number: "PowerCat 6A U/UTP",
    short_description: "Cat6A U/UTP 23AWG bulk cable rated for 10GBASE-T up to 100m.",
    specs: ["Cat6A U/UTP", "500 MHz", "305m box"],
    features: ["Bonded pair", "LSZH available", "Molex warranty", "TIA-568.2-D"],
    availability: "In Stock",
    datasheet_url: "",
    image_url: "",
  },

  // ── Media Converters ────────────────────────────────────────
  {
    id: "mc-001",
    name: "TP-Link Gigabit SFP Media Converter",
    category: "Media Converters",
    brand: "TP-Link",
    model_number: "MC220L",
    short_description: "Gigabit Ethernet to SFP fiber media converter for extended reach.",
    specs: ["1000BASE-T", "1 x SFP", "Standalone"],
    features: ["Auto-negotiation", "Jumbo frame 9K", "Fanless", "Wall/desk mount"],
    availability: "In Stock",
    datasheet_url: "",
    image_url: "",
  },
  {
    id: "mc-002",
    name: "D-Link 100BASE-TX to 100BASE-FX Media Converter",
    category: "Media Converters",
    brand: "D-Link",
    model_number: "DMC-1910R",
    short_description: "Managed media converter, 100BASE-TX to 100BASE-FX single-mode 15km.",
    specs: ["100BASE-TX to FX", "SC SM 15km", "Managed"],
    features: ["Store & forward", "Loop-back mode", "SNMP monitoring", "Fanless"],
    availability: "In Stock",
    datasheet_url: "",
    image_url: "",
  },
  {
    id: "mc-003",
    name: "Allied Telesis Managed Gigabit Media Converter",
    category: "Media Converters",
    brand: "Allied Telesis",
    model_number: "AT-MC1008/SP",
    short_description: "Managed 1000BASE-T to SFP media converter with fault pass-through.",
    specs: ["1000BASE-T", "1 x SFP", "Managed"],
    features: ["Link fault pass-through", "Vision Manager", "IEEE 802.3ah OAM", "Compact"],
    availability: "In Stock",
    datasheet_url: "",
    image_url: "",
  },
  {
    id: "mc-004",
    name: "Netgear Gigabit PoE+ Media Converter",
    category: "Media Converters",
    brand: "Netgear",
    model_number: "GC110P",
    short_description: "Smart cloud-managed gigabit media converter with PoE+ output.",
    specs: ["1000BASE-T + SFP", "PoE+", "Cloud managed"],
    features: ["Insight cloud", "Silent fanless", "Compact metal case", "PoE-out 30W"],
    availability: "In Stock",
    datasheet_url: "",
    image_url: "",
  },
  {
    id: "mc-005",
    name: "Aruba J8177D Gigabit Media Converter",
    category: "Media Converters",
    brand: "HPE Aruba Networking",
    model_number: "J8177D",
    short_description: "1000BASE-T to 1000BASE-SX/LX SFP media converter, unmanaged.",
    specs: ["1000BASE-T + SFP slot", "Unmanaged", "9V DC"],
    features: ["Auto-negotiation", "Auto MDI/MDI-X", "Fanless", "Compact"],
    availability: "In Stock",
    datasheet_url: "",
    image_url: "",
  },

  // ── Network Accessories ─────────────────────────────────────
  {
    id: "acc-001",
    name: "Panduit 1U Horizontal Cable Manager",
    category: "Network Accessories",
    brand: "Panduit",
    model_number: "NCM1WH",
    short_description: "1U metal + plastic finger horizontal cable organizer for 19\" racks.",
    specs: ["1U", "Metal + PVC fingers", "19\" rack"],
    features: ["Front and rear routing", "Removable finger cover", "Bond point", "Black finish"],
    availability: "In Stock",
    datasheet_url: "",
    image_url: "",
  },
  {
    id: "acc-002",
    name: "APC Switched Rack PDU 8-Outlet",
    category: "Network Accessories",
    brand: "APC by Schneider Electric",
    model_number: "AP7900B",
    short_description: "1U 8-outlet switched rack PDU with network mgmt and outlet-level control.",
    specs: ["8 x C13", "16A / 230V", "1U horizontal"],
    features: ["Outlet-level switching", "Network monitoring", "EcoStruxure IT ready", "LCD display"],
    availability: "In Stock",
    datasheet_url: "",
    image_url: "",
  },
  {
    id: "acc-003",
    name: "Belden Cat6A RJ45 Coupler Shielded",
    category: "Network Accessories",
    brand: "Belden",
    model_number: "AX105557",
    short_description: "REVConnect Cat6A shielded coupler for structured cabling extensions.",
    specs: ["Cat6A", "Shielded", "500 MHz"],
    features: ["REVConnect", "Snap-in modular", "Metal shielded", "Tool-less"],
    availability: "In Stock",
    datasheet_url: "",
    image_url: "",
  },
  {
    id: "acc-004",
    name: "Molex RJ45 Cat6 Inline Coupler",
    category: "Network Accessories",
    brand: "Molex",
    model_number: "KPCFAG-002",
    short_description: "Cat6 UTP inline RJ45 coupler for patch extensions.",
    specs: ["Cat6", "UTP", "TIA-568.2-D"],
    features: ["Modular snap-in", "Colour options", "UL listed", "Tool-less"],
    availability: "In Stock",
    datasheet_url: "",
    image_url: "",
  },
  {
    id: "acc-005",
    name: "CommScope Cat6A UTP MRJ21 Cassette",
    category: "Network Accessories",
    brand: "CommScope",
    model_number: "MRJ21-CP",
    short_description: "MRJ21 to RJ45 cassette for high-density Cat6A UTP terminations.",
    specs: ["MRJ21 to 6 x RJ45", "Cat6A UTP", "High-density"],
    features: ["Sliding tray", "Tool-less mount", "Colour icons", "Backwards compatible"],
    availability: "In Stock",
    datasheet_url: "",
    image_url: "",
  },

  // ── IP Phones ───────────────────────────────────────────────
  {
    id: "iph-001",
    name: "Cisco IP Phone 8845 with HD Video",
    category: "IP Phones",
    brand: "Cisco",
    model_number: "CP-8845-K9",
    short_description: "Executive HD video IP phone with 5\" color display and Bluetooth.",
    specs: ["5\" color display", "HD 720p video", "Bluetooth 4.1"],
    features: ["Wideband audio", "10 line keys", "PoE Class 3", "USB port"],
    availability: "In Stock",
    datasheet_url: "",
    image_url: "",
  },
  {
    id: "iph-002",
    name: "Cisco IP Phone 7841 4-Line",
    category: "IP Phones",
    brand: "Cisco",
    model_number: "CP-7841-K9",
    short_description: "Mid-range 4-line SIP IP phone with 3.5\" grayscale display.",
    specs: ["4 lines", "3.5\" display", "Full-duplex speaker"],
    features: ["Wideband G.722", "PoE Class 1", "Dual-position feet", "Headset port"],
    availability: "In Stock",
    datasheet_url: "",
    image_url: "",
  },
  {
    id: "iph-003",
    name: "D-Link Business SIP IP Phone",
    category: "IP Phones",
    brand: "D-Link",
    model_number: "DPH-150SE",
    short_description: "Entry-level SIP business phone with dual Ethernet and PoE.",
    specs: ["2 SIP lines", "2 x LAN 10/100", "PoE 802.3af"],
    features: ["HD voice", "Dual Ethernet", "Headset port", "Compact desk phone"],
    availability: "In Stock",
    datasheet_url: "",
    image_url: "",
  },
  {
    id: "iph-004",
    name: "Huawei eSpace 7910 IP Phone",
    category: "IP Phones",
    brand: "Huawei",
    model_number: "eSpace 7910",
    short_description: "Enterprise-class SIP IP phone with 2.8\" color LCD.",
    specs: ["2.8\" color LCD", "6 SIP accounts", "PoE"],
    features: ["HD voice codec", "Programmable keys", "Wideband audio", "Wall-mount kit"],
    availability: "In Stock",
    datasheet_url: "",
    image_url: "",
  },
  {
    id: "iph-005",
    name: "Ubiquiti UniFi Talk Touch IP Phone",
    category: "IP Phones",
    brand: "Ubiquiti",
    model_number: "UT-Phone-Touch",
    short_description: "Modern IP phone with 5\" touchscreen designed for UniFi Talk.",
    specs: ["5\" touchscreen", "Wideband audio", "PoE + USB-C"],
    features: ["UniFi Talk native", "Bluetooth", "Wi-Fi 5", "1-tap setup"],
    availability: "In Stock",
    datasheet_url: "",
    image_url: "",
  },

  // ── CCTV Networking Equipment ───────────────────────────────
  {
    id: "cctv-001",
    name: "TP-Link 16-Port Gigabit PoE+ Switch for CCTV",
    category: "CCTV Networking Equipment",
    brand: "TP-Link",
    model_number: "TL-SG1218MP",
    short_description: "Rack-mount 18-port PoE+ switch designed for surveillance deployments.",
    specs: ["16 x GE PoE+", "2 x GE", "192W PoE"],
    features: ["Extend Mode 250m", "Isolation Mode", "Priority Mode", "Fanless variant"],
    availability: "In Stock",
    datasheet_url: "",
    image_url: "",
  },
  {
    id: "cctv-002",
    name: "Netgear 24-Port Gigabit PoE+ Smart Switch",
    category: "CCTV Networking Equipment",
    brand: "Netgear",
    model_number: "GS324TP",
    short_description: "24-port PoE+ smart managed pro switch with 190W PoE budget.",
    specs: ["24 x GE PoE+", "2 x SFP", "190W PoE"],
    features: ["ProSAFE Lifetime", "Loop detection", "VLAN & QoS", "Silent under load"],
    availability: "In Stock",
    datasheet_url: "",
    image_url: "",
  },
  {
    id: "cctv-003",
    name: "D-Link 10-Port PoE Surveillance Switch",
    category: "CCTV Networking Equipment",
    brand: "D-Link",
    model_number: "DGS-F1210-10PS-E",
    short_description: "10-port Gigabit surveillance PoE+ switch with long-reach 250m mode.",
    specs: ["8 x GE PoE+", "2 x SFP", "96W PoE"],
    features: ["Surveillance mode", "ONVIF discovery", "PoE watchdog", "Rack-mount"],
    availability: "In Stock",
    datasheet_url: "",
    image_url: "",
  },
  {
    id: "cctv-004",
    name: "Ubiquiti EdgePoint Outdoor Router Switch",
    category: "CCTV Networking Equipment",
    brand: "Ubiquiti",
    model_number: "EP-R8",
    short_description: "Outdoor pole-mount router-switch with 8 x GE ports and PoE passthrough.",
    specs: ["8 x GE", "24V PoE passthrough", "Weatherproof"],
    features: ["EdgeOS", "TOUGHCable ready", "Pole mount", "Bracket included"],
    availability: "In Stock",
    datasheet_url: "",
    image_url: "",
  },
  {
    id: "cctv-005",
    name: "Cisco IE-4000 Industrial Ethernet Switch",
    category: "CCTV Networking Equipment",
    brand: "Cisco",
    model_number: "IE-4000-4TC4G-E",
    short_description: "DIN-rail industrial switch for outdoor surveillance & IoT deployments.",
    specs: ["4 x GE + 4 x FE", "PoE optional", "-40°C to 70°C"],
    features: ["Industrial-grade", "Layer 3", "PROFINET/CIP", "REP redundancy"],
    availability: "In Stock",
    datasheet_url: "",
    image_url: "",
  },

  // ── Data Center Networking Products ─────────────────────────
  {
    id: "dc-001",
    name: "Cisco Nexus 93180YC-FX Data Center Switch",
    category: "Data Center Networking Products",
    brand: "Cisco",
    model_number: "N9K-C93180YC-FX",
    short_description: "1U leaf switch with 48 x 25G downlinks and 6 x 100G uplinks.",
    specs: ["48 x 25G SFP28", "6 x 100G QSFP28", "3.6 Tbps"],
    features: ["Cisco ACI ready", "MACsec", "VXLAN EVPN", "Streaming telemetry"],
    availability: "In Stock",
    datasheet_url: "",
    image_url: "",
  },
  {
    id: "dc-002",
    name: "Juniper QFX5220-32CD 400G Data Center Switch",
    category: "Data Center Networking Products",
    brand: "Juniper Networks",
    model_number: "QFX5220-32CD",
    short_description: "1U 32-port 400G QSFP-DD data center spine/leaf switch.",
    specs: ["32 x 400G QSFP-DD", "12.8 Tbps", "Junos EVO"],
    features: ["EVPN/VXLAN", "Segment routing", "AI-driven ops", "Front-to-back"],
    availability: "In Stock",
    datasheet_url: "",
    image_url: "",
  },
  {
    id: "dc-003",
    name: "Aruba CX 10000 Distributed Services Switch",
    category: "Data Center Networking Products",
    brand: "HPE Aruba Networking",
    model_number: "R9G95A",
    short_description: "48 x 25G leaf switch with in-line Pensando DPUs for stateful services.",
    specs: ["48 x 25G", "6 x 100G", "800 Gbps DPU"],
    features: ["Pensando DPU integration", "Stateful firewall", "Micro-segmentation", "Telemetry"],
    availability: "In Stock",
    datasheet_url: "",
    image_url: "",
  },
  {
    id: "dc-004",
    name: "Huawei CloudEngine 16800 Data Center Switch",
    category: "Data Center Networking Products",
    brand: "Huawei",
    model_number: "CE16816",
    short_description: "AI-native modular data center switch with 400GE port density.",
    specs: ["Modular 16-slot", "768 x 400GE", "iLossless"],
    features: ["Fabric intelligence", "iLossless RoCE", "iMaster NCE-Fabric", "N+M redundancy"],
    availability: "In Stock",
    datasheet_url: "",
    image_url: "",
  },
  {
    id: "dc-005",
    name: "Extreme SLX 9740-40C 400G Data Center Switch",
    category: "Data Center Networking Products",
    brand: "Extreme Networks",
    model_number: "SLX 9740-40C",
    short_description: "1U 40 x 100G / 40 x 400G-capable data center switch with SLX-OS.",
    specs: ["40 x 100/400GE", "16 Tbps", "SLX-OS"],
    features: ["EVPN VXLAN", "Guest OS containers", "Streaming telemetry", "Automation via SLX"],
    availability: "In Stock",
    datasheet_url: "",
    image_url: "",
  },
];
